import { render, staticRenderFns } from "./ModelPlace9Record.vue?vue&type=template&id=2e960dfe&scoped=true&"
import script from "./ModelPlace9Record.vue?vue&type=script&lang=js&"
export * from "./ModelPlace9Record.vue?vue&type=script&lang=js&"
import style0 from "./ModelPlace9Record.vue?vue&type=style&index=0&id=2e960dfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e960dfe",
  null
  
)

export default component.exports